import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';
import { EmojiFallbackHtmlPipe } from '@recruitee/symbol';
import {
  AvatarComponent,
  BadgeComponent,
  DotComponent,
  BoxComponent,
  DividerComponent,
  GroupComponent,
  IconComponent,
  TruncateComponent,
  AttachmentItemComponent,
  DateComponent,
  RtTooltip,
  RemoveHTMLTagsPipe,
} from '@recruitee/user-interface';

import { ActivitiesListComponent } from './activities-list.component';
import { ActivityItemComponent } from './activity-item/activity-item.component';
import { ActivityProfileFieldUpdatedComponent } from './activity-item/activity-profile-field-updated/activity-profile-field-updated.component';

@NgModule({
  imports: [
    AttachmentItemComponent,
    AvatarComponent,
    BadgeComponent,
    BoxComponent,
    CommonModule,
    DateComponent,
    DividerComponent,
    DotComponent,
    GroupComponent,
    I18nModule,
    IconComponent,
    RemoveHTMLTagsPipe,
    RtTooltip,
    TruncateComponent,
    EmojiFallbackHtmlPipe,
    ActivitiesListComponent,
    ActivityItemComponent,
    ActivityProfileFieldUpdatedComponent,
  ],
  exports: [ActivitiesListComponent, ActivityItemComponent, ActivityProfileFieldUpdatedComponent],
})
export class ActivitiesListModule {}
export { ActivitiesListComponent, ActivityItemComponent, ActivityProfileFieldUpdatedComponent };
